import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import State from "./Context/State"
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <State >
      <BrowserRouter >
        <Routes>
          <Route path='/*' element={<App />} />
        </Routes>
      </BrowserRouter>
    </State>
  </React.StrictMode>
);
